export type CvVariant = 'canonical' | 'anthropic'

export const getCvVariant = (): CvVariant => {
  if (typeof window === 'undefined') return 'canonical'

  return new URLSearchParams(window.location.search).get('cv') === 'anthropic'
    ? 'anthropic'
    : 'canonical'
}
